import { Button } from "@mui/material";
import { House } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import "./Support.scss";

const SupporthTML = `
<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Support | Signage play App</title>
    <link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet" />
</head>

<body class="bg-white">

    <div class="min-h-screen bg-white px-4 sm:px-6 lg:px-8 py-16">
        <div class="max-w-3xl mx-auto space-y-10">

            <!-- Header -->
            <header class="text-center">
                <h1 class="text-4xl font-bold" style="color: #4B63BF;">Support Policy</h1>
            </header>

            <!-- Section: How to Get Help -->
            <section class="space-y-6">
                <h2 class="text-xl font-semibold text-gray-800">Contact Us</h2>
                <p class="text-gray-700">
                Signage Play App
                </p>
                Ground Floor, ITC Building, D-Block, G-20, Cross Road,
                Majura Gate, Surat, Gujarat – 395002

                <ul class="list-disc list-inside text-gray-700 space-y-2">
                    <li>
                        <strong>Email Support:</strong>
                        <a href="mailto:support@orail.in" class="hover:underline"
                            style="color: #B937A7;">support@orail.in</a>
                    </li>
                    <li>
                        <strong>Phone Support:</strong>
                        <a href="tel:02613603500" class="hover:underline" style="color: #B937A7;">+91-9510233585</a>
                    </li>
                </ul>
            </section>


            <!-- Section: System Status -->
            <section class="space-y-4">
                <h2 class="text-xl font-semibold text-gray-800">Frequently Asked Questions (FAQ)</h2>
                <p><strong>1. What kind of support do you provide?</strong></p>
                <p class="text-gray-700">
                    We provide support for app usage, device login, ERP connection, content display issues, and 
                    basic troubleshooting.
                </p>
                <p><strong>2. How long does it take to get a response?</strong></p>
                <p class="text-gray-700">
                   We usually respond within 1 business day during working hours.
                </p>
            </section>

            <!-- Section: Support Hours -->
            <section class="space-y-4">
                <h2 class="text-xl font-semibold text-gray-800">Support Hours</h2>
                <p class="text-gray-700">
                    Our support team is available:
                </p>
                <ul class="list-disc list-inside text-gray-700 space-y-2">
                    <li><strong>Monday to Saturday:</strong> 9:30 AM – 6:30 PM (EST)</li>
                    <li><strong>Sunday:</strong> Closed</li>
                </ul>
                <p class="text-gray-600">
                    For inquiries outside these hours, email us and we’ll get back to you as soon as possible.
                </p>
            </section>

             <section class="space-y-4">
                <h2 class="text-xl font-semibold text-gray-800">Support Scope</h2>
                <p class="text-gray-700">
                    Support is provided for:
                </p>
                <ul class="list-disc list-inside text-gray-700 space-y-2">
                    <li><strong>TV app login & device pairing</strong></li>
                    <li><strong>Banner/video display issues</strong></li>
                </ul>
            </section>

            <!-- Section: Feedback -->
            <section class="space-y-4">
                <h2 class="text-xl font-semibold text-gray-800">Feedback and Suggestions</h2>
                <p class="text-gray-700">
                    We value your input! Share your feedback and ideas for improving Signage play App by emailing us at
                    <a href="mailto:support@orail.in" class="hover:underline"
                        style="color: #B937A7;">support@orail.in</a>.
                </p>
            </section>

        </div>
    </div>

</body>

</html>
`;

const Support = () => {
  const navigate = useNavigate();

  return (
    <>
      <div dangerouslySetInnerHTML={{ __html: SupporthTML }}></div>
    </>
  );
};

export default Support;
